module.exports = __webpack_public_path__ + "img/fa-solid-900.13de59f.svg";